const SERIES_PREVIEW_RATINGS = {
  'Stranger Things': '8.6',
  Wednesday: '8.0',
  'Squid Game': '8.0',
  Fallout: '8.3',
  'The Boys': '8.7',
  'The Rings of Power': '7.0',
  'The Mandalorian': '8.6',
  Loki: '8.2',
  Andor: '8.4',
  'House of the Dragon': '8.3',
  'The Last of Us': '8.7',
  'The White Lotus': '8.0',
  Sorgu: '7.5',
  'Var Bunlar': '8.4',
  Vicdansız: '7.1',
  Gibi: '9.0',
  'Sadece Arkadaşız': '6.2',
  'Kara Kenan': '7.4',
  '10 Bin Adım': '7.2',
  'Modern Kadın': '7.5',
  'Ex-Aşkım': '6.8',
};

export const SERIES_PLATFORMS = [
  {
    id: 'netflix', name: 'Netflix', subtitle: 'Global seçki', mark: 'N', brand: 'NETFLIX',
    title: 'Dünyanın konuştuğu diziler.', titleLines: ['Dünyanın', 'konuştuğu diziler.'], status: 'Yeni Eklenen Diziler',
    color: '#e50914', rgb: '229, 9, 20',
    series: [
      { title: 'Stranger Things', meta: 'Bilim kurgu', poster: '/assets/images/showcase/netflix-stranger-things.jpg' },
      { title: 'Wednesday', meta: 'Gizem', poster: '/assets/images/showcase/netflix-wednesday.jpg' },
      { title: 'Squid Game', meta: 'Gerilim', poster: '/assets/images/showcase/netflix-squid-game.jpg' },
      { title: 'Dark', meta: 'Bilim kurgu' },
      { title: 'La Casa de Papel', meta: 'Suç' },
    ],
  },
  {
    id: 'amazon', name: 'Amazon', subtitle: 'Prime Video', mark: 'P', brand: 'PRIME VIDEO',
    title: 'Büyük dünyalar. Cesur hikâyeler.', titleLines: ['Büyük dünyalar.', 'Cesur hikâyeler.'], status: 'Prime Video seçkisi',
    color: '#18a9e6', rgb: '24, 169, 230',
    series: [
      { title: 'Fallout', meta: 'Kıyamet sonrası', poster: '/assets/images/showcase/amazon-fallout.jpg' },
      { title: 'The Boys', meta: 'Süper kahraman', poster: '/assets/images/showcase/amazon-the-boys.jpg' },
      { title: 'The Rings of Power', meta: 'Fantastik', poster: '/assets/images/showcase/amazon-rings-of-power.jpg' },
      { title: 'Reacher', meta: 'Aksiyon' },
      { title: 'Invincible', meta: 'Animasyon' },
    ],
  },
  {
    id: 'disney', name: 'Disney+', subtitle: 'Disney+ seçkisi', mark: 'D+', brand: 'DISNEY+',
    title: 'Galaksilerden çoklu evrene.', titleLines: ['Galaksilerden', 'çoklu evrene.'], status: 'Disney+ seçkisi',
    color: '#6d8cff', rgb: '109, 140, 255',
    series: [
      { title: 'The Mandalorian', meta: 'Uzay macerası', poster: '/assets/images/showcase/disney-mandalorian.jpg' },
      { title: 'Loki', meta: 'Marvel', poster: '/assets/images/showcase/disney-loki.jpg' },
      { title: 'Andor', meta: 'Bilim kurgu', poster: '/assets/images/showcase/disney-andor.jpg' },
      { title: 'Ahsoka', meta: 'Bilim kurgu' },
      { title: 'Percy Jackson ve Olimposlular', meta: 'Fantastik' },
    ],
  },
  {
    id: 'hbo', name: 'HBO', subtitle: 'Prestij dizileri', mark: 'H', brand: 'HBO',
    title: 'Prestij hikâyelerinin adresi.', titleLines: ['Prestij', 'hikâyelerinin adresi.'], status: 'HBO seçkisi',
    color: '#a576ff', rgb: '165, 118, 255',
    series: [
      { title: 'House of the Dragon', meta: 'Fantastik', poster: '/assets/images/showcase/hbo-house-of-the-dragon.jpg' },
      { title: 'The Last of Us', meta: 'Hayatta kalma', poster: '/assets/images/showcase/hbo-the-last-of-us.jpg' },
      { title: 'The White Lotus', meta: 'Drama', poster: '/assets/images/showcase/hbo-white-lotus.jpg' },
      { title: 'Succession', meta: 'Drama' },
      { title: 'Euphoria', meta: 'Drama' },
    ],
  },
  {
    id: 'tod', name: 'TOD', subtitle: 'Yerli originals', mark: 'T', brand: 'TOD',
    title: 'Her hikâye bir iz bırakır.', titleLines: ['Her hikâye', 'bir iz bırakır.'], status: 'TOD Originals',
    color: '#ff6b45', rgb: '255, 107, 69',
    series: [
      { title: 'Sorgu', meta: 'Polisiye', poster: '/assets/images/showcase/tod-sorgu.jpg' },
      { title: 'Var Bunlar', meta: 'Komedi', poster: '/assets/images/showcase/tod-var-bunlar.jpg' },
      { title: 'Vicdansız', meta: 'Dram', poster: '/assets/images/showcase/tod-vicdansiz.jpg' },
      { title: 'Zamanın Kapıları', meta: 'Gerilim' },
      { title: 'Sarmaşık Zamanı', meta: 'Gerilim' },
    ],
  },
  {
    id: 'exxen', name: 'Exxen', subtitle: 'Exxen originals', mark: 'E', brand: 'EXXEN',
    title: 'Kahkaha ve kaos bir arada.', titleLines: ['Kahkaha ve', 'kaos bir arada.'], status: 'Exxen Originals',
    color: '#e7f22b', rgb: '231, 242, 43',
    series: [
      { title: 'Gibi', meta: 'Absürt komedi', poster: '/assets/images/showcase/exxen-gibi.jpg' },
      { title: 'Sadece Arkadaşız', meta: 'Romantik komedi', poster: '/assets/images/showcase/exxen-sadece-arkadasiz.jpg' },
      { title: 'Kara Kenan', meta: 'Orijinal yapım', poster: '/assets/images/showcase/exxen-kara-kenan.jpg' },
      { title: 'Anonim', meta: 'Dönem komedisi' },
      { title: 'Leyla ile Mecnun', meta: 'Absürt komedi' },
    ],
  },
  {
    id: 'gain', name: 'GAİN', subtitle: 'Yeni nesil diziler', mark: 'G', brand: 'GAİN',
    title: 'Şehirli hikâyeler burada.', titleLines: ['Şehirli', 'hikâyeler burada.'], status: 'GAİN seçkisi',
    color: '#ff4e88', rgb: '255, 78, 136',
    series: [
      { title: '10 Bin Adım', meta: 'Komedi', poster: '/assets/images/showcase/gain-10-bin-adim.jpg' },
      { title: 'Modern Kadın', meta: 'Şehir hayatı', poster: '/assets/images/showcase/gain-modern-kadin.jpg' },
      { title: 'Ex-Aşkım', meta: 'Romantik komedi', poster: '/assets/images/showcase/gain-ex-askim.jpg' },
      { title: 'Ayak İşleri', meta: 'Aksiyon / komedi' },
      { title: 'Şahsiyet', meta: 'Polisiye / dram' },
    ],
  },
];

export const SERIES_LIBRARY = SERIES_PLATFORMS.flatMap((platform) => (
  platform.series
    .filter((show) => Boolean(show.poster))
    .map((show, index) => ({
      id: `${platform.id}-${index + 1}`,
      series_id: `${platform.id}-${index + 1}`,
      name: show.title,
      title: show.title,
      genre: show.meta,
      rating: show.rating || SERIES_PREVIEW_RATINGS[show.title] || '',
      yorum_sayisi: show.yorum_sayisi ?? 2,
      poster: show.poster,
      cover: show.poster,
      platformId: platform.id,
      platformName: platform.id === 'amazon' ? 'Prime Video' : platform.name,
      platformMark: platform.mark,
      platformColor: platform.color,
      platformRgb: platform.rgb,
      posterFit: show.title === 'Kara Kenan' ? 'contain' : 'cover',
    }))
));
